import { InputAdornment, OutlinedInput } from '@mui/material';
import { inputOutlined } from 'app/components/Filter/Filter.sx';
import BanknoteIcon from 'app/components/Icons/BanknoteIcon';
import * as React from 'react';

interface Props {
  value: string;
  handleChange: (e: any) => void;
  placeholder: string;
}

const AmountInput = (props: Props) => {
  const { value, handleChange, placeholder } = props;

  return (
    <OutlinedInput
      inputProps={{ style: { paddingLeft: '0px' } }}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      sx={{ ...inputOutlined, gap: '12px', height: '48px' }}
      startAdornment={
        <InputAdornment sx={{ margin: '0px' }} position={'start'}>
          <BanknoteIcon sx={{ fill: 'transparent' }} />
        </InputAdornment>
      }
    />
  );
};

export default AmountInput;
